(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customJs"]) return;
  try {
    
  $(function(){
      $('.questions-toggle dt').click(function(){
          $(this).addClass('active').siblings().removeClass('active');
          $(this).next('dd').addClass('show').siblings().removeClass('show');
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqJs"]) return;
  try {
    
  $(function(){
      $('.search-results-wrapper').before('<img src="https://cdn.shopify.com/s/files/1/0740/2160/1573/files/faq-banner.png?v=1744596370" width="100%" height="100%" class="t4s-d-none t4s-d-lg-block ske-mb-20"/><img src="https://cdn.shopify.com/s/files/1/0740/2160/1573/files/m-faq-banner.png?v=1744604231" width="100%" height="100%" class="t4s-d-lg-none ske-mb-20"/>');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  $(function(){
      $('.see-more').click(function(){
          $('.page-description-info').toggleClass('page-description-show');
          if($('.page-description-info').hasClass('page-description-show')){
              $(this).text('see less');
          }else{
              $(this).text('see more'); 
          }
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // product page ship modal
  $(function(){
      $('.city').click(function(){
          $('.modal-ship').show();
      });
      $('.ship-close').click(function(){
          $('.modal-ship').hide();
      });
  });

  //content after the excerpt is displayed on a new line
  $('.t4s-tab-content ul li').each(function() {
    const text = $(this).text();
    const parts = text.split(':'); 
    if (parts.length === 2) {
      const title = $('<h6></h6>').text(parts[0] + '：');
      $(this).html(title).append(parts[1]);
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
    $(function(){
        $('.wishlist-tabs li').click(function(){
            $(this).addClass('t4s-active').siblings().removeClass('t4s-active');
        });
        $('.wishlist-products').click(function(){
            $('.t4s_empty_page').hide();
            $('.t4s_not_empty_page').show();
        });        
        $('.wishlist-look').click(function(){
            $('.t4s_empty_page').show();
            $('.t4s_not_empty_page').hide();
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection"]) return;
  try {
    
$(document).ready(function(){
    // Get element for dynamic blocks - DC
    var checkExist = setInterval(function() {
      if ($('.has_cats_toggle').length) {
          $('.has_cats_toggle').click(function(){
              $(this).siblings('.sub-menu').toggle();
              $(this).toggleClass('active');
          });
          clearInterval(checkExist);
      }
      if ($('.menu_nested2 .t4s-cat-count').length) {
          $('.menu_nested2 .t4s-cat-count').click(function(){
              $(this).siblings('.sub-menu').toggle();
              $(this).toggleClass('active');
          });
          clearInterval(checkExist);
      }
    }, 100);    
  
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-to-win"]) return;
  try {
    

      window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
      window.LOCALE = 'en';
      window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
    
      window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";
    
      window.GENERIC_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
    
      window.translation = {
        common: {
          selectedList: '{quantity} list selected',
          selectedLists: '{quantity} lists selected'
        }
      };
    
      var AUTOHIDE = Boolean(0);
  
    //window._klOnsite = window._klOnsite || [];
    //window._klOnsite.push(['openForm', 'klaviyo-form-UgiiP7']);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UBKhp4']);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-my-order"]) return;
  try {
    
  $(function(){
    $("#submit_btn").click(function(){
      var email = $("#email").val().trim();
      var order_number = $("#order_number").val().trim();
        if (order_number == '' || order_number == null || order_number == 'undefined') {
        alert('Please enter your order number!');
        return false;
      }
      if (email == '' || email == null || email == 'undefined') {
        alert('Please enter your email address!');
        return false;
      }
      $.ajax({
          url:'https://tbsandbox.co.nz/api/index/shopifyTrackingInfo?order_number=' + order_number + '&email=' + email + '&channel=homemart',
          dataType:'json',
          type:'get',
          processData:false,
          contentType:false,
          mimeType:"multipart/form-data",
          beforeSend:function(){
              $('.pre-loading').show();
          },
          complete:function(){
              $('.pre-loading').hide();
          },
          success:function(res){
            var trackings = '';
            if($.isArray(res) === true) {
              $.each(res, function(key, value){
                trackings += "<tr><td>" + value[1] + "</td><td>" + value[0] + "</td><td><a href='" + value[2] + "' target='_blank'>Track</a></td></tr>";
              });
            } else {
              switch (res) {
                case 400:
                  trackings += "<tr><td colspan='3'>Please check order # is correct.</td></tr>";
                  break;
                case 401:
                  trackings += "<tr><td colspan='3'>Please check order email address is matching your order.</td></tr>";
                  break;
                case 402:
                  trackings += "<tr><td colspan='3'>Tracking information is not available yet.</td></tr>";
                  break; 
              }
            }
            $("#trackings_info").html(trackings);
          }
      })   
    });
  });


  } catch(e) { console.error(e); }
})();
})();
